export const ASSESSMENT_OPTIONS = [
    { value: 'completion', label: 'Зачёт' },
    { value: 'graded_completion', label: 'Зачёт с оценкой' },
    { value: 'exam', label: 'Экзамен' }
];

export const CURRICULUM_KIND_OPTIONS = [
    { value: 'educational', label: 'Учебный' },
    { value: 'educational_and_practical', label: 'Учебно-практический' },
    { value: 'practical_therapeutic_group', label: 'Терапия' },
    { value: 'practical_supervisory_group', label: 'Супервизия' },
    { value: 'intensive', label: 'Интенсив' },
    { value: 'conference', label: 'Конференция' },
    { value: 'final_certification', label: 'Итоговая аттестация' }
];

export const LESSON_TYPE_OPTIONS = [
    { value: 'group', label: 'Группа' },
    { value: 'mini_group', label: 'Мини-группа' },
    { value: 'individual', label: 'Индивидуальное' },
    { value: 'lecture', label: 'Лекция' },
    { value: 'self_study', label: 'Самостоятельная работа' },
    { value: 'attestation', label: 'Аттестация' },
    { value: 'one_day_cycle', label: 'Однодневка' },
    { value: 'two_day_cycle', label: 'Двухдневка' },
    { value: 'three_day_cycle', label: 'Трёхдневка' }
];

const labelOf = (options, value) => options.find((option) => option.value === value)?.label || '';

export const assessmentLabel = (value) => labelOf(ASSESSMENT_OPTIONS, value);
export const lessonTypeLabel = (value) => labelOf(LESSON_TYPE_OPTIONS, value);
export const curriculumKindLabel = (value) => labelOf(CURRICULUM_KIND_OPTIONS, value);

export const formatHours = (value) => {
    if (value === null || value === undefined || value === '') return '';
    const number = Number(value);
    if (!Number.isFinite(number)) return String(value);
    return Number.isInteger(number) ? String(number) : String(number).replace(/\.?0+$/, '');
};

export const formatMoney = (value) => {
    const number = Number(value);
    if (!Number.isFinite(number) || number <= 0) return '';
    return `${number.toLocaleString('ru-RU')} ₽`;
};
